const headerSelector = 'header';

export const getHeaderElement = (): HTMLElement => {
  // Header element is always present on the page.
  return document.querySelector(headerSelector);
};
